import { faFolder } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Link } from 'react-router';
import { UserPagePathBuilder } from '@user/pages/UserPagePathBuilder';
import { HighlightText } from './HighlightText';
import { classNames } from '@framework/utils';
import type { FolderId, WorkspaceId } from 'balus-common';

type Props = {
  workspaceId: WorkspaceId;
  folderId: FolderId;
  folderName: string;
  searchKeyword?: string;
  isExternal?: boolean;
};

export const FolderItemTitle: React.FC<Props> = ({
  workspaceId,
  folderId,
  folderName,
  searchKeyword,
  isExternal = false,
}: Props) => {
  return (
    <Link
      to={UserPagePathBuilder.workspaceFolderPage(workspaceId, folderId)}
      className={classNames('flex w-full items-center rounded-sm py-1 pr-1 focus:outline-none')}
      {...(isExternal && { target: '_blank', rel: 'noopener noreferrer' })}
    >
      <FontAwesomeIcon icon={faFolder} className="mr-1 text-brand" />
      <HighlightText className="truncate" text={folderName} keyword={searchKeyword || ''} />
    </Link>
  );
};
